import { render } from "./Button.vue?vue&type=template&id=bc59fe50&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=bc59fe50&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bc59fe50"

export default script